// 枚举 - 地形图类型
let mapStyles;
((mapStyles) => {
  mapStyles[(mapStyles["Pachy"] = 0)] = "Pachy";
  mapStyles[(mapStyles["TCurvatureF"] = 1)] = "TCurvatureF";
  mapStyles[(mapStyles["TCurvatureB"] = 2)] = "TCurvatureB";
  mapStyles[(mapStyles["SCurvatureF"] = 3)] = "SCurvatureF";
  mapStyles[(mapStyles["SCurvatureB"] = 4)] = "SCurvatureB";
  mapStyles[(mapStyles["ElevationF"] = 5)] = "ElevationF";
  mapStyles[(mapStyles["ElevationB"] = 6)] = "ElevationB";
  mapStyles[(mapStyles["TrueNetPower"] = 7)] = "TrueNetPower";
  mapStyles[(mapStyles["KPD"] = 8)] = "KPD";
  mapStyles[(mapStyles["FRP"] = 9)] = "FRP";
  mapStyles[(mapStyles["ACDI"] = 10)] = "ACDI";
  mapStyles[(mapStyles["BelinF"] = 11)] = "BelinF";
  mapStyles[(mapStyles["BelinB"] = 12)] = "BelinB";
  mapStyles[(mapStyles["BelinDiff3F"] = 13)] = "BelinDiff3F";
  mapStyles[(mapStyles["BelinDiff3B"] = 14)] = "BelinDiff3B";
  mapStyles[(mapStyles["TearThickness"] = 15)] = "TearThickness";
  mapStyles[(mapStyles["TCP"] = 16)] = "TCP";
  mapStyles[(mapStyles["HeightF"] = 17)] = "HeightF";
  mapStyles[(mapStyles["TFSQ"] = 18)] = "TFSQ";
  mapStyles[(mapStyles["Zernike"] = 60)] = "Zernike";
  mapStyles[(mapStyles["Diff"] = 61)] = "Diff";
})(mapStyles || (mapStyles = {}));
export const NORMALMAPSTYLES = [
  "TCurvatureF",
  "SCurvatureF",
  "ElevationF",
  "FRP",
  "HeightF",
  "TFSQ"
];
let dataShapsOnMap;
((dataShapsOnMap) => {
  dataShapsOnMap[(dataShapsOnMap["ShowApexPosition"] = 0)] = "ShowApexPosition";
  dataShapsOnMap[(dataShapsOnMap["ShowMinRadiusF"] = 1)] = "ShowMinRadiusF";
  dataShapsOnMap[(dataShapsOnMap["ShowPupilCenter"] = 2)] = "ShowPupilCenter";
  dataShapsOnMap[(dataShapsOnMap["ShowAlpha"] = 3)] = "ShowAlpha";
  dataShapsOnMap[(dataShapsOnMap["ShowMaxPeak"] = 4)] = "ShowMaxPeak";
  dataShapsOnMap[(dataShapsOnMap["ShowPupilEdge"] = 5)] = "ShowPupilEdge";
  dataShapsOnMap[(dataShapsOnMap["ShowNasalTemp"] = 6)] = "ShowNasalTemp";
  dataShapsOnMap[(dataShapsOnMap["ShowEyeType"] = 7)] = "ShowEyeType";
  dataShapsOnMap[(dataShapsOnMap["ShowNinemmBorder"] = 8)] = "ShowNinemmBorder";
  dataShapsOnMap[(dataShapsOnMap["ShowDiameter9mm"] = 9)] = "ShowDiameter9mm";
  dataShapsOnMap[(dataShapsOnMap["ShowNumericValues"] = 10)] = "ShowNumericValues";
  dataShapsOnMap[(dataShapsOnMap["ShowMaxMin"] = 11)] = "ShowMaxMin";
})(dataShapsOnMap || (dataShapsOnMap = {}));
export const MAPSTYLES = mapStyles;
export const DATASHAPSONMAP = dataShapsOnMap;

let fillColorStatus;
((fillColorStatus) => {
  fillColorStatus[(fillColorStatus["FC_OK"] = 0)] = "FC_OK";
  fillColorStatus[(fillColorStatus["FC_ERR_FLAGDATA"] = 1)] = "FC_ERR_FLAGDATA";
  fillColorStatus[(fillColorStatus["FC_ERR_DATA"] = 2)] = "FC_ERR_DATA";
  fillColorStatus[(fillColorStatus["FC_ERR_DATAPTR"] = 3)] = "FC_ERR_DATAPTR";
  fillColorStatus[(fillColorStatus["FC_NOT_MATCH"] = 4)] = "FC_NOT_MATCH";
  fillColorStatus[(fillColorStatus["FC_ERR_COLORSTYLE"] = 5)] = "FC_ERR_COLORSTYLE";
  fillColorStatus[(fillColorStatus["FC_ERR_CMTYPE"] = 6)] = "FC_ERR_CMTYPE";
  fillColorStatus[(fillColorStatus["FC_ERR_COLORNUM"] = 7)] = "FC_ERR_COLORNUM";
  fillColorStatus[(fillColorStatus["FC_ERR_CENTRALVAL"] = 8)] = "FC_ERR_CENTRALVAL";
  fillColorStatus[(fillColorStatus["FC_ERR_SI_CS"] = 9)] = "FC_ERR_SI_CS";
  fillColorStatus[(fillColorStatus["FC_ERR_BLKDOT_PARA"] = 10)] = "FC_ERR_BLKDOT_PARA";
  fillColorStatus[(fillColorStatus["FC_ERR_CT_ISD_NOT_MATCH"] = 11)] = "FC_ERR_CT_ISD_NOT_MATCH";
  fillColorStatus[(fillColorStatus["FC_ERR_BITMAPPTR"] = 12)] = "FC_ERR_BITMAPPTR";
  fillColorStatus[(fillColorStatus["FC_ERR_XY"] = 13)] = "FC_ERR_XY";
})(fillColorStatus || (fillColorStatus = {}));
export const FILL_COLOR_STATUS = fillColorStatus;

let colorStyles;
((colorStyles) => {
  colorStyles[(colorStyles["emOculus"] = 0)] = "emOculus";
  colorStyles[(colorStyles["style1"] = 1)] = "style1"; // emHollPrimary
  colorStyles[(colorStyles["standard"] = 2)] = "standard"; // emAmerican
  colorStyles[(colorStyles["style2"] = 3)] = "style2"; // emBelin
  colorStyles[(colorStyles["style3"] = 4)] = "style3"; // emSmole
  colorStyles[(colorStyles["style4"] = 5)] = "style4"; // emTMS
  colorStyles[(colorStyles["emBelinDiff3"] = 6)] = "emBelinDiff3";
  colorStyles[(colorStyles["fluorescence"] = 7)] = "fluorescence";
  colorStyles[(colorStyles["style5"] = 8)] = "style5"; // medmont
  colorStyles[(colorStyles["emNone"] = -1)] = "emNone";
})(colorStyles || (colorStyles = {}));
export const COLOR_STYLES = colorStyles;
var majMedianModes;
(function (majMedianModes) {
  majMedianModes[(majMedianModes["ecc"] = 0)] = "ecc";
  majMedianModes[(majMedianModes["E"] = 1)] = "E";
  majMedianModes[(majMedianModes["P"] = 2)] = "P";
  majMedianModes[(majMedianModes["Q"] = 3)] = "Q";
  majMedianModes[(majMedianModes["SAGCURV"] = 4)] = "SAGCURV";
})(majMedianModes || (majMedianModes = {}));

export const MAJMEDIANMODES = majMedianModes;
export const FLATCOLOR = "lightgreen";
export const STEEPCOLOR = "red";
export const INVALID_1000 = -1000;
export const FILES = {
  acdotana: "AC.ANA",
  originImage: "original.jpg",
  originImageTh: "original_th.jpg",
  edgeImgPath: "placidoimage.jpg",
  pupilEdge: "epupil.eds",
  tanF: "TANF.MMV",
  sagF: "SAGF.MMV",
  cartSagf: "SAGF.CART",
  cartCrnf: "CRNF.CART",
  cartTanf: "TANF.CART",
  cartFlgf: "FLGF.CART",
  cartFrp: "FRP.CART",
  cartTfsq: "TFSQ.CART",
  cartHeightF: "HEIGHTF.CART",
  calibImage: "CalibImage.jpg",
  calib: "calib.ini",
  calibRingsLarge: "RingsLarge_coordinatesXY_360.dat",
  calibRingsLargeHuman: "RingsLargeHum_coordinatesXY_360.dat",
  calibRingsLittle: "RingsLittle_coordinatesXY_360.dat",
  calibRingsLittleHuman: "RingsLittleHum_coordinatesXY_360.dat",
  shotJson: "shot.json"
};



// WEBPACK FOOTER //
// ./src/topography/shared/consts.js